<template>
    <div id="ap">
        <a-layout>
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between">
                        <a-col span="8">
                            <common-page-btn></common-page-btn>
                        </a-col>
                        <a-col span="16">
                            <a-row type="flex" align="middle" justify="end" :gutter="10">
                                <a-col span="6">
                                    <a-input v-model="param.keyword" allowClear search @pressEnter="getList"
                                        @on-clear="getList" placeholder="关键词查询"></a-input>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
        </a-layout>

        <a-layout>
            <a-layout-content>
                <a-table :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false" :indentSize="25"
                    :style="{ background: '#FFF' }" size="small" row-key="couponId" border :columns="keys" ref="list"
                    :loading="loading" :data-source="data.records">
                    <template slot-scope="row" slot="name">
                        <a href="#">{{ row.title }}</a>
                    </template>
                    <template slot-scope="row" slot="coupon">
                        <a-space>
                            <span v-if="row.discount > 0">{{ row.discount / 10 }}折</span>
                            <span v-if="row.money > 0">{{ row.money }} 元 </span>
                            <span>{{ row.couponType }}</span>
                            <span v-if="row.fullMoney > 0">消费满{{ row.fullMoney }}元可用</span>
                        </a-space>
                    </template>
                    <template slot-scope="row" slot="state">
                        <a-tag v-if="!row.isUsed" color="green">未使用</a-tag>
                        <a-tag v-else color="red">已使用</a-tag>
                    </template>
                    <template slot-scope="row" slot="action">
                        <a-button-group shape="circle" size="small">
                            <a-tooltip title="删除作废"><a-button type="link" v-has="'coupon:data:delete'" icon="delete"
                                    @click="del(row.couponId)"></a-button></a-tooltip>
                        </a-button-group>
                    </template>
                </a-table>
            </a-layout-content>
        </a-layout>
        <a-row>
            <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                    @showSizeChange="setLimit" :current="data.current" />
            </a-col>
        </a-row>
    </div>
</template>

<script>
import apiUtil from "@/common/apiUtil";
import ExporttoExcel from "@/common/ExportExcel.js";
import utils from '@/common/utils';
export default {
    data() {
        return {
            confirmLoading: false,
            visible: false,
            loading: false,
            status: '',
            data: { records: [] },
            param: {
                page: 1,
                limit: 20,
                keyword: '',
            },
            keys: [
                { title: '用户', dataIndex: 'nickName', width: 180, ellipsis: true },
                { title: '卡号', dataIndex: 'code', align: 'left', ellipsis: true },
                { title: '面值', customRender: (row) => { return '￥' + row.money; }, width: 160, align: 'left', ellipsis: true },
                { title: '余额', customRender: (row) => { return '￥' + row.balance; }, width: 160, align: 'left', ellipsis: true },
                { title: '来源订单', dataIndex: 'source', width: 240, align: 'center', ellipsis: true },
                { title: '获得时间', dataIndex: 'createTime', width: 200, align: 'center', ellipsis: true },
                { title: '有效期', dataIndex: 'overDate', width: 200, align: 'center', ellipsis: true },
                { title: '状态', scopedSlots: { customRender: 'state' }, width: 160, align: 'center', ellipsis: true },
                { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
            ],
        };
    },
    created() {
        this.doRefresh();
    },
    methods: {
        organChange() {
            this.param.cateId = '';
            this.doRefresh();
        },
        //删除
        del(id) {
            this.utils.confirm('删除后无法恢复，是否确认?').then(() => {
                utils.showSpin();
                this.http.delete('/platform/coupon/ticket/delete/' + id).then(ret => {
                    if (ret.code == 200) {
                        this.utils.success('操作成功！').then(() => {
                            this.getList();
                        });
                    }
                });
            });
        },
        // 获取数据
        getList() {
            this.loading = true;
            this.http
                .get('/platform/coupon/ticket/list', this.param)
                .then(ret => {
                    // console.log(ret);
                    this.data = ret.data;
                }).finally(() => {
                    this.loading = false;
                });
        },
        // 导出excel
        ExportEx() {
            if (this.data.records.length > 0) {
                const filterData = this.data.records.map((item) => {
                    return { '商户名称': item.name, "负责人": item.person, "手机号": item.phone, "地址": item.address, "提交日期": item.createDate, "所属单位": item.organName, "备注": item.remark, "状态": item.status };
                });
                const organ = apiUtil.getOrganList().filter(item => item.organId == this.param.organId);
                let organName = '';
                if (organ.length == 0) {
                    organName = "所有单位";
                } else {
                    organName = organ[0].name;
                }
                ExporttoExcel(filterData, `${organName}商户记录表.xlsx`);
            } else {
                this.$message.info('没有数据哦！！!');
                return;
            }
        },
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
};
</script>

<style scoped></style>
